import { parseFieldsArrayToObject } from '@interlayer/js/app/components/main/Registration/utils/parseFieldsArrayToObject';
import { CUSTOM_VALIDATION_FIELDS, VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

import { TRetailPersonalFields } from './types';

export const RETAIL_PERSONAL_FIELDS: TRetailPersonalFields[] = [
    VALIDATION_FIELDS.email,
    VALIDATION_FIELDS.gender,
    VALIDATION_FIELDS.firstname,
    VALIDATION_FIELDS.lastname,
    VALIDATION_FIELDS.dateOfBirth
];

export const RETAIL_PERSONAL_DATA = parseFieldsArrayToObject(RETAIL_PERSONAL_FIELDS);

export const VALIDATION_RETAIL_PERSONAL_FIELDS = [
    ...RETAIL_PERSONAL_FIELDS,
    CUSTOM_VALIDATION_FIELDS.duplicate
];
